import "./Model.css";

const Modal = ({ modalData, setOpenModal }) => {
  console.log("modelllll", modalData);
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{"Org Details"}</h3>
        <div className="dialog-data">
          <p>
            <span>Org Name -</span>
            {modalData && modalData.orgName}
          </p>
          <p>
            <span>Org Domain Url- </span>
            {modalData && modalData.orgDomainURL}
          </p>
          <p>
            <span>Organization Logo - </span>
            {modalData && modalData.orgLogo}
          </p>
          <p>
            <span>Org Address- </span> {modalData && modalData.orgAddress}
          </p>
          <p>
            <span>Org Phone Number-</span>{" "}
            {modalData && modalData.orgPhoneNumber}
          </p>
          <p>
            <span>Org GSTIN - </span> {modalData && modalData.orgGSTIN}
          </p>
          <p>
            <span>Org Company Name -</span>{" "}
            {modalData && modalData.orgCompanyName}
          </p>
        </div>

        <div className="modal-button">
          <button className="view-btn" onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
